import React from 'react';
import OptionButton from '../shared/OptionButton';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const options = [
  { label: 'Male', value: 'MALE' },
  { label: 'Female', value: 'FEMALE' },
  { label: 'Prefer Not to Say', value: 'PREFER NOT TO SAY' },
];

const GenderStep: React.FC<StepProps> = ({ answer, onAnswer }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {options.map((opt) => (
        <OptionButton
          key={opt.value}
          label={opt.label}
          value={opt.value}
          selected={answer === opt.value}
          onClick={onAnswer}
        />
      ))}
    </div>
  );
};

export default GenderStep;
